import { isNumber } from 'radash';

type MeasurementRange = { min?: number | null; nom?: number | null; max?: number | null };

const hasMeasurementValue = (measurement: MeasurementRange | null | undefined): boolean =>
    [measurement?.min, measurement?.nom, measurement?.max].some(isNumber);

export type { MeasurementRange };
export { hasMeasurementValue };
